"use strict";

import axios from "axios";
import crypto from "crypto";
import qs from "querystring";

const PATERN_HOST =
  location.protocol.indexOf("https") !== -1
    ? /(https:\/\/|www\.)\S+/i
    : /(http:\/\/|www\.)\S+/i;

export default {
  install (Vue, config) {
    const Issuer = config && config.Issuer ? config.Issuer : "";
    const ClientId = config && config.ClientId ? config.ClientId : "";
    const ClientSecret =
      config && config.ClientSecret ? config.ClientSecret : "";
    const RedirectUri = config && config.RedirectUri ? config.RedirectUri : "";
    // const PostLogoutRedirecUri =
    //   config && config.PostLogoutRedirecUri ? config.PostLogoutRedirecUri : "";
    const Scope = config && config.Scope ? config.Scope : "";
    const ResponseType =
      config && config.ResponseType ? config.ResponseType : "";

    const instance = new Vue();
    const Util = instance.$util;
    const Message = instance.$message;
    const Storage = instance.$storage;

    const TOKEN_REFRESH_THRESHOLD = 60 * 1000; // 1 minuto antes de expirar

    const Services = {
      getProfile () {
        return _http("get", "me");
      },

      getOidc () {
        const state = crypto.randomBytes(64).toString("hex");
        const nonce = crypto.randomBytes(64).toString("hex");
        return `${Issuer}auth?client_id=${ClientId}&scope=${Scope}&response_type=${ResponseType}&redirect_uri=${RedirectUri}&state=${state}&nonce=${nonce}`;
      },

      postVerificaToken (token) {
        return _httpqs("post", "token/introspection", {
          token: token.replaceAll('"', ""),
          client_id: ClientId,
          client_secret: ClientSecret
        });
      },

      postAccesToken (code) {
        return _httpqs("post", `token`, {
          grant_type: "authorization_code",
          code: code,
          redirect_uri: RedirectUri,
          client_id: ClientId,
          client_secret: ClientSecret
        });
      },

      postRefreshToken (refreshToken) {
        return _httpqs("post", "token", {
          grant_type: "refresh_token",
          refresh_token: refreshToken,
          redirect_uri: RedirectUri,
          client_id: ClientId,
          client_secret: ClientSecret
        });
      },

      saveOidcTokens (response) {
        const data = response.data || response;
        if (!data) return;
        if (data.access_token) {
          Storage.setSession("access_token", data.access_token);
        }
        if (data.refresh_token) {
          Storage.setSession("refresh_token", data.refresh_token);
        }
        if (data.expires_in) {
          Storage.setSession("expires_at", Date.now() + data.expires_in * 1000);
        }
      },

      refreshTokenIfNeeded () {
        const self = this;
        const accessToken = Storage.getSession("access_token");
        if (!accessToken) {
          return Promise.reject(new Error("No OIDC access token"));
        }
        const refreshToken = Storage.getSession("refresh_token");
        const expiresAt = Storage.getSession("expires_at");
        const now = Date.now();
        if (refreshToken && expiresAt && now >= expiresAt - TOKEN_REFRESH_THRESHOLD) {
          return self.postRefreshToken(refreshToken)
            .then(response => {
              const data = response.data || response;
              if (data && data.access_token) {
                self.saveOidcTokens(data);
                return true;
              }
              return Promise.reject(new Error("OIDC refresh response invalid"));
            })
            .catch(error => {
              console.error("Error refrescando token OIDC", error);
              return Promise.reject(error);
            });
        }
        return Promise.resolve(true);
      }
    };

    function getUrl (url, id) {
      id =
        typeof id === "string" || typeof id === "number"
          ? `${id}`
          : typeof id === "object" && id.id
          ? `${id.id}`
          : "";
      if (url[url.length - 1] !== "/" && id.length > 1) {
        id = `/${id}`;
      }
      return PATERN_HOST.test(url) ? url + id : Issuer + url + id;
    }

    function _http (method, url, data) {
      url = getUrl(url, data);
      console.group("Petición con DataService:");
      console.info("URL:", method.toUpperCase(), url);
      if (data) {
        console.info("Params:", data);
      }

      let setting = {
        method,
        url,
        headers: {
          Authorization: `Bearer ${sessionStorage
            .getItem("legalizacion-web_access_token")
            .replaceAll('"', "")}`
        }
      };

      if (typeof data === "object" && Object.keys(data).length) {
        delete data.id;
        setting.data = data;
      }

      return axios(setting)
        .then(response => filterResponse(response.data))
        .catch(error => handlingErrors(error));
    }

    function _httpqs (method, url, data) {
      url = getUrl(url, data);
      console.group("Petición con DataService Oidc:");
      console.info("URL:", method.toUpperCase(), url);
      if (data) {
        console.info("Params:", data);
      }

      let setting = {
        method,
        header: { "content-type": "application/x-www-form-urlencoded" },
        url
      };

      if (typeof data === "object" && Object.keys(data).length) {
        delete data.id;
        setting.data = qs.stringify(data);
      }

      return axios(setting)
        .then(response => filterResponse(response.data))
        .catch(error => handlingErrors(error));
    }

    function filterResponse (response) {
      let data = response.data || response.datos || response;
      console.info("Respuesta:");
      if (Util.toType(data) === "array") {
        if (window.navigator.appName === "Netscape") {
          console.log("firefox");
          console.table(data);
        } else {
          console.table(data.map(item => [item]));
        }
      } else {
        console.dir(data);
      }
      console.groupEnd();
      return response;
    }

    function handlingErrors (error) {
      if (error.response) {
        let data = error.response.data;
        Message.error(data.message || "Error desconocido del servidor");
        console.error(data.message || "Error desconocido del servidor");
      } else {
        console.error(error.message || "Error desconocido");
      }
    }

    Vue.prototype.$serviceoidc = Services;
    Vue.prototype.$httpoidc = axios;
    Vue.prototype.$apiUrloidc = Issuer;
  }
};



// WEBPACK FOOTER //
// ./src/lib/service.oidc.js